// Import database API
import {
    getAboutFileSignedUrl,
    uploadAboutFile,
} from '../database/endpoints/about.api';

// Import libs
import { getJson } from '../libs/getJson';

// About files path
const CONTACTS_FILE_PATH = 'contacts.json';
const DELIVERY_FILE_PATH = 'delivery.json';
const SCHEDULES_FILE_PATH = 'schedules.json';

// The default time after signed urls are invalid
const SIGNED_URL_TIMEOUT = Number(
    process.env.REACT_APP_DATABASE_SIGNED_URL_TIMEOUT,
);

// ------------------------------------------------------------------------------
// FETCHER
// ------------------------------------------------------------------------------

// Function to fetch contacts infos
export async function fetchContactsInfos() {
    try {
        // Get Signed url for contacts file
        const contactsSignedUrl = await getAboutFileSignedUrl(
            CONTACTS_FILE_PATH,
            SIGNED_URL_TIMEOUT,
        );

        // Fetch json file for contact infos
        const contactsJson = await getJson(contactsSignedUrl);

        // return the datas in a gloabl object
        return {
            instagram: contactsJson.instagram,
            whats_app: contactsJson.whats_app,
        };
    } catch (err) {
        console.error(
            `Error while loading contacts infos\nError message: ${err.message}`,
        );
        throw err;
    }
}

// Function to fetch delivery infos
export async function fetchDeliveryInfos() {
    try {
        // Get Signed url for delivery file
        const deliverySignedUrl = await getAboutFileSignedUrl(
            DELIVERY_FILE_PATH,
            SIGNED_URL_TIMEOUT,
        );

        // Fetch the json file for delivery info
        const deliveryJson = await getJson(deliverySignedUrl);

        // Return the text of the file
        return deliveryJson.delivery_text;
    } catch (err) {
        console.error(
            `Error while loading delivery infos\nError message: ${err.message}`,
        );
        throw err;
    }
}

// Function to fetch schedules infos
export async function fetchSchedulesInfos() {
    try {
        // Get Signed url for schedules file
        const schedulesSignedUrl = await getAboutFileSignedUrl(
            SCHEDULES_FILE_PATH,
            SIGNED_URL_TIMEOUT,
        );

        // Fetch the json file for schedules info
        const schedulesJson = await getJson(schedulesSignedUrl);

        // Return the text of the file
        return schedulesJson.schedules_text;
    } catch (err) {
        console.error(
            `Error while loading schedules infos\nError message: ${err.message}`,
        );
        throw err;
    }
}

// ------------------------------------------------------------------------------
// UPDATERS
// ------------------------------------------------------------------------------

// Function to update about contact infos
export async function updateContactsInfos(instagram, whatsApp) {
    try {
        // If one of the link is not definied throw an error
        if (
            !instagram ||
            !whatsApp ||
            !instagram.length > 0 ||
            !whatsApp.length > 0
        ) {
            throw new Error("Instagram or What's App are empty or undefined");
        }

        // Create the json file
        const contactsJson = {
            instagram: instagram,
            whats_app: whatsApp,
        };

        // Convert the json file into binary large object
        const contactBlob = new Blob([JSON.stringify(contactsJson, null, 2)], {
            type: 'application/json',
        });

        // Try to upload the new file
        await uploadAboutFile(CONTACTS_FILE_PATH, contactBlob);
    } catch (err) {
        console.error(
            `Error while updating contacts infos\nError message: ${err.message}`,
        );
        throw err;
    }
}

// Function to update delivery infos
export async function updateDeliveryInfos(text) {
    try {
        // If the text is not definied throw an error
        if (!text || !text.length > 0) {
            throw new Error('Delivery text is empty or undefined');
        }

        // Create the json file
        const deliveryJson = {
            delivery_text: text,
        };

        // Convert the json file into binary large object
        const deliveryBlob = new Blob([JSON.stringify(deliveryJson, null, 2)], {
            type: 'application/json',
        });

        // Try to upload the new file
        await uploadAboutFile(DELIVERY_FILE_PATH, deliveryBlob);
    } catch (err) {
        console.error(
            `Error while updating delivery infos\nError message: ${err.message}`,
        );
        throw err;
    }
}

// Function to update delivery infos
export async function updateSchedulesInfos(text) {
    try {
        // If the text is not definied throw an error
        if (!text || !text.length > 0) {
            throw new Error('Delivery text is empty or undefined');
        }

        // Create the json file
        const schedulesJson = {
            schedules_text: text,
        };

        // Convert the json file into binary large object
        const schedulesBlob = new Blob(
            [JSON.stringify(schedulesJson, null, 2)],
            { type: 'application/json' },
        );

        // Try to upload the new file
        await uploadAboutFile(SCHEDULES_FILE_PATH, schedulesBlob);
    } catch (err) {
        console.error(
            `Error while updating schedules infos\nError message: ${err.message}`,
        );
        throw err;
    }
}
